const UPSELL_STEPS = {
    PLAN_SELECTED: 1,
    ADD_UPGRADE: 2,
    ORDER_CONFIRMATION: 3
};

export {
    UPSELL_STEPS
};
